import React, {useRef} from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../../gd-components/gd-popover/popover"
import FieldSelectView from "../../select-view"
import VScroll from "../../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import FieldSelectView_PopoverOption from "./popover-option"
import PopupMenuButton from "../../../../../../gd-components/popover-menu/popup-menu-button/popup-menu-button";
import ProjectView_MoreMenu
    from "../../../../../../../layout/top/header/project/submenu/submenu-item/more-popover/more-menu";
import PopoverMenuOption, {PopoverMenuOptionSelectionType} from "../../../../../../gd-components/popover-menu/popover-menu/menu-option";
import header_toggleIsCompact
    from "../../../../../../../layout/top/header/project/submenu/toggle-button/function/toggle-is-compact";
import {PopoverAttachmentType} from "../../../../../../gd-components/gd-popover/@const";

const debug = false
// const debug = "FieldSelectView_Popover"

export default function FieldSelectView_Popover(props:any) {

    const refNewView: any = useRef()

    const onClickOutside = (e:any) => {
        if (refNewView.current?.isPopoverShown) return
        // if (gd.utils.Dom.findNodeByClassName(e.target, ["top-project-views-popover", "popover-project-view"])) return

        props.parent.hidePopover()
    }

    const onSelect = (value:ID) => {
        debug && console.log(debug, 'onSelect', value)

        props.parent.hidePopover()
        props.parent.onValueChange(value)
    }

    const field : FieldSelectView = props.field
    const value = field.getViewValue(props.model)

    debug && console.log(debug, 'render', value, field.views, props.model)

    const onCustomize = ()=>{
        header_toggleIsCompact(props.model.projectViews.project.id)
    }

    const customizeOption = {
        icon    : "i5-pen",
        label   : "Customize"
    }

    return (
        <Popover attachmentType     = "horizontal"
                 attachment         = "top center"
                 targetAttachment   = "bottom center"
                 onClickOutside     = {onClickOutside}
                 clickOutsideDelay  = {300}
                 getTargetFunc      = {()=>findDOMNode(props.parent)}>
            <div className="ui5-popover-menu with-help w-200 max-h-500 flex-column-left-top">
                <VScroll>
                    {_.map(field.views, view =>{
                        return <FieldSelectView_PopoverOption key           = {view.id}
                                                              view          = {view}
                                                              isSelected    = {view.id === value}
                                                              onSelect      = {onSelect}/>
                    })}
                    <div className="separator"/>
                    <PopoverMenuOption className        = "m-b-5"
                                       option           = {customizeOption}
                                       onClick          = {onCustomize}
                                       isSelected       = {false}>
                    </PopoverMenuOption>
                </VScroll>
            </div>
        </Popover>
    )
}
